/**
 * 团队空间
 */

import { RouteRecordRaw } from "vue-router";

export const groupChildrenRoutes: RouteRecordRaw[] = [
  {
    path: "space",
    name: "group-space",
    component: () => import("@/views/group/space/index.vue"),
    meta: {
      title: "会员中心",
      auth: true,
      layout: "simple",
      label: "会员中心",
      useTopbar: true,
      layoutHidden: true
    }
  },
  {
    path: "dashboard",
    name: "group-dashboard",
    component: () => import("@/views/group/dashboard/index.vue"),
    meta: {
      title: "算力仪表盘",
      auth: true,
      layout: "simple",
      label: "算力仪表盘",
      useTopbar: true,
      layoutHidden: true
    }
  },
  {
    path: "seats",
    name: "group-seats",
    component: () => import("@/views/group/seats/index.vue"),
    meta: {
      title: "成员列表",
      auth: true,
      label: "成员列表",
      layout: "simple",
      useTopbar: true,
      layoutHidden: true
    }
  },
  {
    path: "orders",
    name: "group-orders",
    component: () => import("@/views/group/orders/index.vue"),
    meta: {
      title: "团队订单/发票",
      auth: true,
      label: "团队订单/发票",
      layout: "simple",
      useTopbar: true,
      layoutHidden: true
    }
  }
];

const groupRoutes: RouteRecordRaw[] = [
  {
    path: "/group",
    name: "group",
    component: () => import("@/views/group/group-layout.vue"),
    redirect: "/group/space",
    meta: {
      title: "团队订单（发票）",
      auth: true,
      layout: "simple",
      label: "团队订单（发票）",
      useTopbar: true,
      layoutHidden: true
    },
    children: [...groupChildrenRoutes]
  }
];
export default groupRoutes;
